import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.52 8a.76.76 0 0 1-.75.75H5.23a.75.75 0 0 1 0-1.5h5.54a.75.75 0 0 1 .75.75Zm3.23 0A6.75 6.75 0 1 1 8 1.25 6.75 6.75 0 0 1 14.75 8Zm-3.23 0a.75.75 0 0 0-.75-.75H5.23a.75.75 0 0 0 0 1.5h5.54a.76.76 0 0 0 .75-.75Zm-.75-.75H5.23a.75.75 0 0 0 0 1.5h5.54a.75.75 0 0 0 0-1.5Z';
const draw24px =
  'M21.74,12A9.75,9.75,0,1,1,12,2.25,9.76,9.76,0,0,1,21.74,12ZM18,12a1,1,0,0,0-1-1H7a1,1,0,0,0,0,2H17A1,1,0,0,0,18,12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const MinusCircleFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'minusCircleFilled')) as IconWithRender;

MinusCircleFilledIcon.displayName = 'MinusCircleFilledIcon';
MinusCircleFilledIcon.propTypes = Icon.propTypes;
MinusCircleFilledIcon.renderIcon = (props) => (
  <MinusCircleFilledIcon {...props} />
);
export default MinusCircleFilledIcon;
